import { createContext } from "react";

const globalStorage = createContext()

export default globalStorage